export default __webpack_public_path__ + "static/media/Asset wallet.ddecb082.svg";